// tslint:disable:max-line-length
export var checkboxIconSvgData = "<svg width=\"10\" height=\"8\" viewBox=\"0 0 10 8\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M1.702 2.787L.298 4.213l3.247 3.196 5.701-5.702L7.832.293 3.534 4.59z\" fill-rule=\"nonzero\"/></svg>";
//# sourceMappingURL=checkbox-icon.js.map